<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Prelims-new-page" lang="en-GB">To those who’ve joined me wishing<br/>under the tent,<br/>the stars,<br/>and on the backs of our bikes.</p>
<p class="Prelims-main" lang="en-GB">With special thanks to those<br/>Who helped me publish my work,<br/>My greatest supporters.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB-3.vue?59830484